import axios from "axios";
import React from "react";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import ReactTooltip from "react-tooltip";
import "../../../src/assets/scss/intel.scss";
import { getApiUrl } from "../../utils/baseUrl";
import trackingEventDictionary from "../../../src/core/dictionary/tracking-event";
import { generateTrackingObject, getCompanyComingFrom } from "../../../src/core/global/global-country-functions";
import { trademoTrackingEvents } from "../../../src/core/global/trademo-tracking";
import { generateQueryString } from "../../core/utility/utility";
import { getIntelUrl } from "../../utils/intelUrl";
import { profileTypeEnum } from "@components/templates/Profile/ProfileHeader/profile-enum";
import { setRedirectionIdsArrayHandler } from "@redux/User/userDetailsSlice";
import { connect } from "react-redux";
const websitelAPIEndpoints = {
  getCompanySlug: getApiUrl("companyProfiles/getSlug"),
};
class ImporterExporterCompanyName extends React.Component {
  navigateUserToCompanyProfile = (data) => {
    if (this.props && this.props.currentTab && this.props.currentTab === "importers" && this.props.analyticsCountryID && this.props.pathname && this.props.currentUserPlan) {
      if (this.props.isTwoLevel) {
        if (this.props.isTrendsTab) {
          this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabTrends2ndLevelAnalyticsCompanyProfile, generateTrackingObject(this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan));
        } else {
          this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabRank2ndLevelAnalyticsCompanyProfileClick, generateTrackingObject(this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan));
        }
      } else {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabCompanyProfileClick, generateTrackingObject(this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan));
      }
    } else if (this.props && this.props.currentTab && this.props.currentTab === "exporters" && this.props.analyticsCountryID && this.props.pathname && this.props.currentUserPlan) {
      if (this.props.isTwoLevel) {
        if (this.props.isTrendsTab) {
          this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabTrends2ndLevelAnalyticsCompanyProfile, generateTrackingObject(this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan));
        } else {
          this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabRank2ndLevelAnalyticsCompanyProfileClick, generateTrackingObject(this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan));
        }
      } else {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabCompanyProfileClick, generateTrackingObject(this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan));
      }
    } else if (this.props && this.props.currentTab && this.props.currentTab === "logistics" && this.props.analyticsCountryID && this.props.pathname && this.props.currentUserPlan) {
      if (this.props.isTwoLevel) {
        if (this.props.isTrendsTab) {
          this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabTrends2ndLevelAnalyticsCompanyProfile, generateTrackingObject(this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan));
        } else {
          this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabRank2ndLevelAnalyticsCompanyProfileClick, generateTrackingObject(this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan));
        }
      } else {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabCompanyProfileClick, generateTrackingObject(this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan));
      }
    }
    if (!(!!data.rowData.key && data.rowData.key !== "" && !!data.rowData[data.companyIdKey] && data.rowData[data.companyIdKey] !== "")) {
      toast.error("Data not found. Please try again later !!!");
      return false;
    }
    const companyId = data.rowData[data.companyIdKey];
    this.props.setRedirectionIdsArrayHandler(companyId);
    const params = {
      companyId: companyId,
    };
    let tempPathName = this.props.pathname + "%%" + companyId + "%%" + this.props.rowData.key;
    axios
      .get(websitelAPIEndpoints.getCompanySlug, { params })
      .then((res) => {
        if (!!res && !!res.data && !!res.data.status && res.data.status.toUpperCase() === "success".toUpperCase()) {
          if (!!res.data.data && !!res.data.data.companySlug && res.data.data.companySlug !== "") {
            let url = "";
            let queryParams = {
              country: this.props.countryName ? (this.props.countryName === "US" ? this.props.countryName : this.props.countryName.toLowerCase() === "united kingdom" ? "uk" : this.props.countryName.toLowerCase()) : "colombia",
              type: this.props.countryType ? this.props.countryType.toLowerCase() : "export",
              tab: this.props.currentTab === "exporters" ? "E" : "I",
            };
            if (!!this && !!this.props && !!this.props.type && this.props.type !== "") {
              queryParams.comingFrom = getCompanyComingFrom(this.props.type);
            }
            let queryString = generateQueryString(queryParams);
            url = getIntelUrl() + "companies/" + res.data.data.companySlug + "/" + res.data.data.aliasCompanyId + "?" + queryString;
            let isMerged = new URLSearchParams(this.props.location.search).get("isMerged");
            let mergedId = new URLSearchParams(this.props.location.search).get("mergedID");
            let companyExporterId = new URLSearchParams(this.props.location.search).get("companyExporterId");
            let companyImporterId = new URLSearchParams(this.props.location.search).get("companyImporterId");
            let companyLogisticsId = new URLSearchParams(this.props.location.search).get("companyLogisticsId");
            if (isMerged) {
              if (this.props.currentTab === "importers" && companyImporterId) {
                url = url + `&isMerged=${isMerged}&mergedID=${mergedId}`;
              } else if (this.props.currentTab === "exporters" && companyExporterId) {
                url = url + `&isMerged=${isMerged}&mergedID=${mergedId}`;
              } else if (this.props.currentTab === "logistics" && companyLogisticsId) {
                url = url + `&isMerged=${isMerged}&mergedID=${mergedId}`;
              }
            }
            if (!!url && url !== "") {
              window.open(url, "_blank");
            } else {
              toast.error("Something went wrong. Please try again later !!!");
            }
          } else {
            if (this.props.analyticsCountryID && this.props.pathname && this.props.currentUserPlan) {
              this.checkPendoEventForCompanyRedirection(trackingEventDictionary.noCompanyFound, generateTrackingObject(this.props.analyticsCountryID, tempPathName, this.props.currentUserPlan));
            }
            toast.error("No company profile found in our system !!!");
          }
        } else {
          if (this.props.analyticsCountryID && this.props.pathname && this.props.currentUserPlan) {
            this.checkPendoEventForCompanyRedirection(trackingEventDictionary.noCompanyFound, generateTrackingObject(this.props.analyticsCountryID, tempPathName, this.props.currentUserPlan));
          }
          toast.error("No company profile found in our system !!!");
        }
      })
      .catch(() => {
        toast.error("Something went wrong. Please try again later !!!");
      });
  };
  checkPendoEventForCompanyRedirection(event) {
    let tempEvent;
    const searchUrlParams = window.location.search;
    for (let [key, value] of Object.entries(trackingEventDictionary)) {
      if (event && key && value === event) {
        tempEvent = key;
      }
    }
    tempEvent = "companyRedirection" + tempEvent[0].toUpperCase() + tempEvent.slice(1);
    let redirectionFrom = new URLSearchParams(searchUrlParams).get("redirectingFrom");
    let trackEvent = trackingEventDictionary[tempEvent];
    if (redirectionFrom === profileTypeEnum.tradeLanes) {
      trackEvent = trackEvent.replace("company", "tradelane");
    } else if (redirectionFrom === profileTypeEnum.ports) {
      trackEvent = trackEvent.replace("company", "ports");
    } else if (redirectionFrom === profileTypeEnum.logistics) {
      trackEvent = trackEvent.replace("company", "logistics_company");
    }
    if (tempEvent && trackingEventDictionary && trackingEventDictionary[tempEvent] && this.props.isRedirect && (this.props.redirectingCompanyExporterId || this.props.redirectingCompanyImporterId || this.props.redirectingCompanyLogisticsId)) {
      trademoTrackingEvents(trackEvent, generateTrackingObject(this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan));
    } else {
      trademoTrackingEvents(event, generateTrackingObject(this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan));
    }
  }
  render() {
    return (
      <span className="tw-flex tw-gap-1">
        {this.props && this.props.rowData && this.props.rowData.key && this.props.rowData.key !== "" && this.props.companyIdKey && this.props.rowData[this.props.companyIdKey] && this.props.rowData[this.props.companyIdKey] !== "" ? (
          <span className="w-100" data-tip={this.props.rowData.key} data-for="id_4">
            <button type="button" className={`trademo-link text-left px-0 text-capitalize ${this.props.redirectionIdsArr.includes(this.props.rowData[this.props.companyIdKey]) ? "text_visited" : ""}`} onClick={this.navigateUserToCompanyProfile.bind(this, this.props)}>
              {(this.props.showTwoLevel || this.props.isTrendsTab) && this.props.rowData.key.length >= 26 ? this.props.rowData.key.slice(0, 26) + "..." : this.props.rowData.key}
            </button>
            <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" id="id_4" />
          </span>
        ) : this.props && !!this.props.rowData && !!this.props.rowData.key && this.props.rowData.key !== "" ? (
          <span className="w-100" data-tip={this.props.rowData.key} data-for="id_4">
            {(this.props.showTwoLevel || this.props.isTrendsTab) && this.props.rowData.key.length >= 26 ? this.props.rowData.key.slice(0, 26) + "..." : this.props.rowData.key}
            <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" id="id_4" />
          </span>
        ) : (
          <span className="d-none">Not Declared</span>
        )}
        {(() => {
          const { nthRow, rowData } = this.props;
          if (!this.props.canViewIec) return null;
          return Array.isArray(nthRow?.subProperties) && nthRow.subProperties.length ? (
            nthRow.subProperties.map(
              (item, index) =>
                rowData[nthRow.subProperties[index].selector] &&
                rowData[nthRow.subProperties[index].selector] !== "" && (
                  <span key={item} className={item.className}>
                    {rowData[nthRow.subProperties[index].selector]}
                  </span>
                )
            )
          ) : !window.location.pathname.includes("india-search") && rowData?.iec_number && rowData?.iec_number !== "" && !this.props.starterUser ? (
            <span className="tw-bg-gray-200 tw-font-medium tw-border tw-rounded-[14px] tw-py-[3.2px] tw-px-2 tw-h-fit">{rowData.iec_number}</span>
          ) : null;
        })()}
      </span>
    );
  }
}

function mapStateToProps(state) {
  const { userDetails } = state;
  return { redirectionIdsArr: userDetails?.redirectionIdsArr ?? [] };
}
const mapDispatchToProps = {
  setRedirectionIdsArrayHandler: (data) => setRedirectionIdsArrayHandler(data),
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ImporterExporterCompanyName));
